import { createContext, useContext } from 'react';
import { AppUrlBuilder } from '../AppUrlBuilder';

export const AppUrlBuilderContext = createContext<AppUrlBuilder>(undefined!);

export const useAppUrlBuilderContext = () => {
  return useContext(AppUrlBuilderContext);
};
